import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { MaterialModule } from 'src/app/material.module';
import { DashboardProgramariComponent } from './dashboard-programari.component';
import { DashboardProgramariService } from './dashboard-programari.service';

@NgModule({
    declarations: [
        DashboardProgramariComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgChartsModule,
        MaterialModule
    ],
    exports: [
        DashboardProgramariComponent
    ],
    providers: [
        DashboardProgramariService
    ]
})
export class DashboardProgramariModule { }
